import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingSection} from '@tempo/landing';
import {LandingHeading} from '@tempo/landing';
import {useRouter} from 'next/router';
import {Youtube} from '@app/components/Iframe/Youtube';
import {Box} from '@tempo/core';

const useSongCatcherVideoLink = (): readonly [string] => {
	const {locale} = useRouter();
	return [locale === 'fr' ? 'LuXbv7FdEOQ' : 'ulFYExcN6-M'];
};

export const SongcatcherLive: FunctionComponent = () => {
	const {t} = useTranslation();
	const [link] = useSongCatcherVideoLink();

	return (
		<LandingSection pr={4} pl={4}>
			<LandingHeading as="h2">
				{t(
					'songcatcherlandingpage_title_watchoursongcatchertutorial_standalone-web',
					{ns: 'songcatcher'},
				)}
			</LandingHeading>
			<Box>
				<Youtube mt={20} videoId={link} />
			</Box>
		</LandingSection>
	);
};
